import { FieldMetaProps, getIn, useFormikContext } from 'formik';
import { ParagraphExtraSmall } from 'lib/components/styles/typography';
import React, { CSSProperties } from 'react';
import { useCovideoTheme } from 'react-covideo-common';

interface IFormikImageUploadErrorMessageProps {
  name: string;
  meta: FieldMetaProps<any>;
  extendStyles?: {
    errorWrapper?: CSSProperties | undefined;
  };
}

export const FormikImageUploadErrorMessage = ({
  name,
  meta,
  extendStyles,
}: IFormikImageUploadErrorMessageProps) => {
  const themes = useCovideoTheme();
  const { errors } = useFormikContext();
  const error: { url: string } = getIn(errors, name);
  return (
    <div style={{ height: 16, ...extendStyles?.errorWrapper }}>
      {error && meta.touched ? (
        <ParagraphExtraSmall color={themes.colors.danger[80]}>
          {error.url}
        </ParagraphExtraSmall>
      ) : null}
    </div>
  );
};
